module.exports = __webpack_public_path__ + "img/siteIcons-01.c6315420.png";